import React from "react";
import cx from "classnames";

const FormGroup = ({ label, className, children }) => (
  <div className={className}>
    {label && (
      <label
        className={cx(
          "block font-mulish text-12-18 text-gold tracking-8 font-bold pb-6 mb-20 uppercase",
          { "border-b border-gray-light": label }
        )}>
        {label}
      </label>
    )}
    <div className="flex flex-col space-y-16">{children}</div>
  </div>
);
FormGroup.defaultProps = {
  label: "",
  className: "",
};

export default FormGroup;
